const routeradmin = `https://carta-multimedia.onrender.com/api/`; //live
// const routeradmin = `http://localhost:4900/api/`; //test
// const Live = https://carta-multimedia.onrender.com
export default class routerAdmin {
  exames = `${routeradmin}admin/exames`;
  questions = `${routeradmin}admin/question`;
  photo = `${routeradmin}admin/photo`;
  user = `${routeradmin}user`;
  doacoes = `${routeradmin}doacoes`;
}
